import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { API_BASE_URL } from "../../../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const AppraisalRequest = () => {
  const [data, setData] = useState(null);
  const [rows, setRows] = useState({});
  const [loading, setLoading] = useState(false);
  const [departmentId, setDepartmentId] = useState(0);
const [searchText, setSearchText] = useState("");
const filteredEmployees = useMemo(() => {
  if (!data?.employees) return [];

  return data.employees.filter((e) =>
    e.employee_name
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );
}, [data, searchText]);

  /* ===============================
     LOAD DATA
  ================================*/
const getCurrentPageEmployees = () => {
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  return filteredEmployees.slice(start, end);
};


  const [currentPage, setCurrentPage] = useState(1);
const [rowsPerPage, setRowsPerPage] = useState(10);

  const loadData = () => {
    setLoading(true);
    axios
      .get(
        `${API_BASE_URL}/appraisal/employees?department_id=${departmentId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      .then((res) => {
        const safe = {
          employees: res.data.employees || [],
          forms: res.data.forms || [],
          incharges: res.data.incharges || [],
          hods: res.data.hods || [],
          hrs: res.data.hrs || [],
          managements: res.data.managements || [],
          others: res.data.others || [],
          departments: res.data.departments || [],
        };

        setData(safe);
const defaultFormId =
  safe.forms.length > 0 ? String(safe.forms[0].form_id) : "";

const temp = {};
safe.employees.forEach((e) => {
  temp[e.user_id] = {
  checked: e.status !== 1 && !!e.form_id,

  form_id: e.form_id ? String(e.form_id) : "",

    incharge_id: e.incharge_id ? String(e.incharge_id) : "",
    hod_id: e.hod_id ? String(e.hod_id) : "",
    hr_id: e.hr_id ? String(e.hr_id) : "",        // ✅ FIX
    management_id: e.management_id ? String(e.management_id) : "",
    others_id: "",
  };
});




        setRows(temp);
      })
      .catch(() => toast.error("Failed to load data"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadData();
  }, []);

  /* ===============================
     UPDATE ROW
  ================================*/
  const updateRow = (uid, key, value) => {
    setRows((prev) => ({
      ...prev,
      [uid]: { ...prev[uid], [key]: value },
    }));
  };
const departmentOptions = data?.departments
  ? data.departments.map((d) => ({
      value: d.department_id,
      label: d.department_name,
    }))
  : [];


  /* ===============================
     SEND REQUEST
  ================================*/
  const sendRequest = () => {
  const currentEmployees = getCurrentPageEmployees();

  const payload = currentEmployees
    .filter((e) => rows[e.user_id]?.checked)
    .map((e) => ({
      employee_id: e.user_id,
      ...rows[e.user_id],
    }));

  if (!payload.length) {
    toast.warning("Select at least one employee from current page");
    return;
  }

  const invalid = payload.find((p) => !p.form_id);
  if (invalid) {
    toast.error("Please select Form for all selected employees");
    return;
  }

  axios
    .post(`${API_BASE_URL}/appraisal/send`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    })
    .then(() => {
      toast.success("Appraisal request sent (current page only)");
      loadData();
    })
    .catch(() => toast.error("Send failed"));
};


  /* ===============================
     TABLE COLUMNS
  ================================*/
  const columns = useMemo(
    () => [
      {
        name: "",
        width: "40px",
        cell: (e) => (
         <input
  type="checkbox"
  disabled={e.status === 1 || !rows[e.user_id]?.form_id}
  checked={rows[e.user_id]?.checked || false}
  onChange={(ev) =>
    updateRow(e.user_id, "checked", ev.target.checked)
  }
/>

        ),
      },
      {
        name: "Employee Name",
        selector: (e) => e.employee_name,
        wrap: true,
      },
      {
  name: "Department",
  selector: (e) => e.department_name,
  wrap: true,
  width: "200px",
},

      {
        name: "Joining Date",
        selector: (e) => e.join_date,
        width: "120px",
      },
     {
  name: "Form",
  width: "240px",
  cell: (e) => (
    <select
      className="form-select form-select-sm appraisal-select appraisal-col-wide"
      value={rows[e.user_id]?.form_id || ""}
      disabled={e.status === 1}
      onChange={(ev) => {
        const value = ev.target.value;
        updateRow(e.user_id, "form_id", value);

        if (value) {
          updateRow(e.user_id, "checked", true); // ✅ AUTO CHECK
        }
      }}
    >
      <option value="">Select</option>
      {data.forms.map((f) => (
        <option key={f.form_id} value={f.form_id}>
          {f.form_title}
        </option>
      ))}
    </select>
  ),
}
,
   {
  name: "Incharge",
  width: "180px",
  cell: (e) => (
    <select
      className="form-select form-select-sm appraisal-select"
      value={rows[e.user_id]?.incharge_id || ""}
      disabled={e.status === 1}
      onChange={(ev) =>
        updateRow(e.user_id, "incharge_id", ev.target.value)
      }
    >
      <option value="">Select</option>
      {data.incharges.map((i) => (
        <option key={i.user_id} value={i.user_id}>
          {i.name}
        </option>
      ))}
    </select>
  ),
}
,
     {
  name: "HOD",
  width: "180px",
  cell: (e) => (
    <select
      className="form-select form-select-sm appraisal-select"
      value={rows[e.user_id]?.hod_id || ""}
      disabled={e.status === 1}
      onChange={(ev) =>
        updateRow(e.user_id, "hod_id", ev.target.value)
      }
    >
      <option value="">Select</option>
      {data.hods.map((h) => (
        <option key={h.user_id} value={h.user_id}>
          {h.name}
        </option>
      ))}
    </select>
  ),
},

   {
  name: "HR",
  width: "180px",
  cell: (e) => (
    <select
      className="form-select form-select-sm appraisal-select"
      value={rows[e.user_id]?.hr_id || ""}
      disabled={e.status === 1}
      onChange={(ev) =>
        updateRow(e.user_id, "hr_id", String(ev.target.value))
      }
    >
      <option value="">Select</option>
      {data.hrs.map((h) => (
        <option key={h.user_id} value={String(h.user_id)}>
          {h.name}
        </option>
      ))}
    </select>
  ),
}
,

   {
  name: "Management",
  width: "220px",
  cell: (e) => (
    <select
      className="form-select form-select-sm appraisal-select appraisal-col-wide"
      value={rows[e.user_id]?.management_id || ""}
      disabled={e.status === 1}
      onChange={(ev) =>
        updateRow(e.user_id, "management_id", ev.target.value)
      }
    >
      <option value="">Select</option>
      {data.managements.map((m) => (
        <option key={m.user_id} value={m.user_id}>
          {m.name}
        </option>
      ))}
    </select>
  ),
}
,
   {
  name: "Others",
  width: "220px",
  cell: (e) => (
    <select
      className="form-select form-select-sm appraisal-select appraisal-col-wide"
      value={rows[e.user_id]?.others_id || ""}
      disabled={e.status === 1}
      onChange={(ev) =>
        updateRow(e.user_id, "others_id", ev.target.value)
      }
    >
      <option value="">Select</option>
      {data.others.map((o) => (
        <option key={o.user_id} value={o.user_id}>
          {o.employee_name}
        </option>
      ))}
    </select>
  ),
}
,  


      {
        name: "Status",
        width: "90px",
        cell: (e) => (
          <span className={`badge ${e.status ? "bg-success" : "bg-warning"}`}>
            {e.status ? "Sent" : "Pending"}
          </span>
        ),
      },
    ],
    [rows, data]
  );

  if (!data) return <div className="p-4">Loading...</div>;

  return (
    <>
      <ToastContainer position="bottom-right" />

      {/* ===== Department Filter ===== */}
    <div className="card p-3 mb-3">
  <h3 className="card-title d-flex align-items-center mb-3" style={{ color: "#1d3a8a", fontWeight: 600 }}>
    <i className="fa fa-star mr-2" style={{ fontSize: "20px" }} />
    Appraisal
  </h3>
  <div className="row align-items-end g-2">
    <div className="col-md-4">
      <label className="form-label fw-bold">Department</label>

     <Select
  className="dept-select"
  classNamePrefix="dept"
  options={[
    { value: 0, label: "All Departments" },
    ...departmentOptions,
  ]}
  value={
    departmentOptions.find((o) => o.value === departmentId) || {
      value: 0,
      label: "All Departments",
    }
  }
  onChange={(selected) => setDepartmentId(selected.value)}
  isSearchable
  placeholder="Select Department"
/>

    </div>

    <div className="col-md-2">
      <button
        className="btn btn-primary btn-sm"
        onClick={loadData}
      >
        GET
      </button>
    </div>
  </div>
</div>
<div className="d-flex justify-content-end mb-2">
  <div style={{ width: "250px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search employee..."
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
    />
  </div>
</div>




      {/* ===== Table ===== */}
   <DataTable
  columns={columns}
  data={filteredEmployees}
  progressPending={loading}
  pagination
  paginationPerPage={10}
  paginationRowsPerPageOptions={[10, 25, 50, 100]}
  striped
  dense
  persistTableHead

  onChangePage={(page) => setCurrentPage(page)}
  onChangeRowsPerPage={(newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  }}
/>



      <div className="mt-3 text-end">
        <button className="btn btn-primary" onClick={sendRequest}>
          Send Request
        </button>
      </div>
    </>
  );
};

export default AppraisalRequest;
